import { useReducer } from 'react'

type ActionType = 'LOAD' | 'ERROR' | 'SUCCESS' | 'INITIAL'

export default function useCheckoutStatus() {
  const [state, dispatch] = useReducer(
    (
      _state: { loading: boolean; error: boolean; success: boolean },
      action: { type: ActionType },
    ) => {
      switch (action.type) {
        case 'LOAD':
          return {
            loading: true,
            error: false,
            success: false,
          }
        case 'ERROR':
          return {
            loading: false,
            error: true,
            success: false,
          }
        case 'SUCCESS':
          return {
            loading: false,
            error: false,
            success: true,
          }
        case 'INITIAL':
          return {
            loading: false,
            error: false,
            success: false,
          }
      }
    },
    {
      loading: false,
      error: false,
      success: false,
    },
  )

  return {
    ...state,
    setStatus: (type: ActionType) => dispatch({ type }),
  }
}
